import { render, staticRenderFns } from "./MultipleOrdersResourceCard.vue?vue&type=template&id=4a6335bc&"
import script from "./MultipleOrdersResourceCard.vue?vue&type=script&lang=js&"
export * from "./MultipleOrdersResourceCard.vue?vue&type=script&lang=js&"
import style0 from "./MultipleOrdersResourceCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports